export const wrapper = ["bg-transparent", "border-none", "w-10", "h-10"];
export const container = ["inline-block", "m-auto"];
export const line1 = ["block", "w-6", "h-0.5", "bg-secondary", "transform", "rotate-45", "-mb-0.5"];
export const line2 = ["block", "w-6", "h-0.5", "bg-secondary", "transform", "-rotate-45", "-mt-px"];
